import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AbstractEditPage} from "./abstract-edit-page";
import {FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";

@Injectable()
export class CanDeactivateEditPage implements CanDeactivate<AbstractEditPage> {

    constructor(private alertsService: FUIAlertService, private alertNewService: FUIAlertService) {
    }

    canDeactivate(component: AbstractEditPage, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot,
                  nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (component instanceof AbstractEditPage && !component.canDeactivate()) {
            return this.deactivate(currentState);
        } else {
            return true;
        }
    }

    deactivate(currentState: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            this.alertNewService.showConfirmationOkCancel("wbo.edit.prompt.discard.heading", "wbo.edit.prompt.discard.message")
                .subscribe((action) => {
                    if (action === FUIAlertActions.OK_ACTION) {
                        resolve(true);
                    } else {
                        // currently there is a bug on angular that when the back button is used and the canDeactivate return false
                        // it stills change the browser history causing the history to get in a wrong state. So this is just an
                        // workaround until they fix this angular bug
                        history.pushState({}, "", currentState.url);
                        resolve(false);
                    }
                });
        });
    }
}
